import React from 'react'
import clsx from 'clsx'
// import {useLocation} from 'react-router'
import { checkIsActive, WithChildren } from '../../../../helpers'
import { DynamicIcon } from '../../../../../components/DynamicIcon'
import { useLayout } from '../../../core'
import { useLocation, useNavigate } from 'react-router-dom'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  withRoute?: boolean
  dataTour?: string
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  withRoute,
  dataTour,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)

  // Check if any child is active by examining the children's routes
  const isChildActive = React.useMemo(() => {
    if (!children) return false

    const childrenArray = React.Children.toArray(children)
    return childrenArray.some((child: any) => {
      const childTo = child?.props?.to
      return childTo && checkIsActive(pathname, childTo)
    })
  }, [children, pathname])

  const isParentActive = isActive || isChildActive

  const { config } = useLayout()
  const { app } = config
  const navigate = useNavigate()
  return (
    <div
      className={clsx('menu-item', 'menu-accordion', { 'here show': isParentActive })}
      style={{ border: 'none', outline: 'none' }}
      data-kt-menu-trigger='click'
    >
      <span onClick={() => withRoute && navigate(to)} className={clsx('menu-link', { active: isParentActive })} data-tour={dataTour}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon' style={{ transitionDelay: "0.2s" }}>
            <DynamicIcon name={icon} size={22} />
          </span>
        )}
        <span className='menu-title' style={{ transitionDelay: "0.2s" }}>{title}</span>
        <span className='menu-arrow'></span>
      </span>


      <div
        className={clsx('border-start menu-sub menu-sub-accordion', { 'menu-active-bg': isParentActive })}
      >
        {children}
      </div>
    </div>
  )
}

export { SidebarMenuItemWithSub }
